import { privateAxiosIntance } from "../../Config/axios";
import { API_URLS } from "../../Config/urls";

export const getImagesFn = () => {
    try {
        const response = privateAxiosIntance.get(API_URLS.images);
        return response;
    } catch (error) {
        throw error;
    }
}

export const postImagesFn = (req) => {
    try {
        const response = privateAxiosIntance.post(API_URLS.images,req);
        return response;
    } catch (error) {
        throw error;
    }
}

export const deleteImagesFn = (req) => {
    try {
        const response = privateAxiosIntance.delete(API_URLS.images,{
            data:req
        });
        return response;
    } catch (error) {
        throw error;
    }
}